import { useRootStore } from "@/state/RootStore";
import type { Test } from "@/state/TestsStore";

/**
 * Returns the tests map filtered by deleted test IDs.
 * No useMemo — MobX observer on consuming components handles
 * re-render optimization. useMemo would cache stale results
 * because in-place Map mutations don't change the reference.
 */
export function useVisibleTests(): Map<string, Test> {
  const store = useRootStore();
  const { tests, deletedTestIds } = store.testStore;

  const visible = new Map<string, Test>();
  tests.forEach((test, id) => {
    if (!deletedTestIds.get(id)) {
      visible.set(id, test);
    }
  });
  return visible;
}
